export interface Problema {
  type?: string;
  title?: string;
  detail?: string;
  status: number;
  codigo: string;
  incidente?: string;
  momento?: string;
  contexto?: Record<string, unknown>;
  errores?: ErrorDeCampo[];
}

export interface ErrorDeCampo {
  campo: string;
  mensaje: string;
}

export class ErrorDeApi extends Error {
  constructor(readonly problema: Problema) {
    super(problema.detail ?? problema.title ?? 'ERROR EN LA SOLICITUD');
    this.name = 'ErrorDeApi';
  }

  get codigo(): string {
    return this.problema.codigo;
  }

  get status(): number {
    return this.problema.status;
  }

  get erroresDeCampo(): ErrorDeCampo[] {
    return this.problema.errores ?? [];
  }

  esNoAutenticado(): boolean {
    return this.status === 401;
  }

  esSinPermiso(): boolean {
    return this.status === 403;
  }

  esReglaDeNegocio(): boolean {
    return this.status === 422;
  }
}
